import { FC } from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { BreadcrumbsItem } from "../../types/ui";
import { Link } from "react-router-dom";
import { useStyles } from "./styles";

interface Props {
  items: BreadcrumbsItem[];
}

const BitaBreadcrumbs: FC<Props> = ({ items }) => {
  const classes = useStyles();

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
      {items.map(({ key, label, href }, idx) => (
        <Link
          key={key}
          className={classes.link}
          to={href}
          color="inherit"
          style={{ fontWeight: idx === items.length - 1 ? "700" : "500" }}
        >
          {label}
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default BitaBreadcrumbs;
